<template>
  <el-dialog
    :title="$t('editSysDocumentView.title')"
    :visible.sync="dialogVisible"
    width="70%"
    @close="handleClose"
  >
    <el-form :model="form" :rules="rules" ref="form" label-width="120px">
      <el-form-item :label="$t('editSysDocumentView.docTitle')" prop="docTitle">
        <el-input
          v-model="form.docTitle"
          :placeholder="$t('editSysDocumentView.docTitlePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editSysDocumentView.docCode')" prop="docCode">
        <el-input
          v-model="form.docCode"
          :placeholder="$t('editSysDocumentView.docCodePlaceholder')"
        ></el-input>
      </el-form-item>
      <el-form-item :label="$t('editSysDocumentView.docContent')" prop="docContent">
        <el-input
          type="textarea"
          :rows="10"
          v-model="form.docContent"
          :placeholder="$t('editSysDocumentView.docContentPlaceholder')"
        ></el-input>
      </el-form-item>
    </el-form>
    <span slot="footer" class="dialog-footer">
      <el-button @click="handleClose">{{ $t('common.cancel') }}</el-button>
      <el-button type="primary" @click="submitForm">{{ $t('common.save') }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { updateSysDocument } from '@/api/dev/sysDocument/sysDocumentApi'
import { getShopId } from '@/api/shop/shopApi'

export default {
  name: 'EditSysDocumentView',
  data() {
    return {
      dialogVisible: false,
      form: {
        docId: '',
        docTitle: '',
        docCode: '',
        docContent: '',
        shopId: ''
      },
      rules: {
        docTitle: [
          { required: true, message: this.$t('editSysDocumentView.docTitleRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('editSysDocumentView.docTitleMaxLength'), trigger: 'blur' }
        ],
        docCode: [
          { required: true, message: this.$t('editSysDocumentView.docCodeRequired'), trigger: 'blur' },
          { max: 200, message: this.$t('editSysDocumentView.docCodeMaxLength'), trigger: 'blur' }
        ],
        docContent: [
          { required: true, message: this.$t('editSysDocumentView.docContentRequired'), trigger: 'blur' }
        ],
        docId: [
          { required: true, message: this.$t('editSysDocumentView.docIdRequired'), trigger: 'blur' }
        ]
      }
    }
  },
  methods: {
    open(data) {
      this.form = {
        ...data,
        shopId: getShopId()
      }
      this.dialogVisible = true
    },
    handleClose() {
      this.dialogVisible = false
      this.$refs.form.resetFields()
      this.$emit('close')
    },
    submitForm() {
      this.$refs.form.validate(async valid => {
        if (valid) {
          try {
            await updateSysDocument(this.form)
            this.$message.success(this.$t('editSysDocumentView.updateSuccess'))
            this.handleClose()
          } catch (error) {
            console.error('更新文档失败:', error)
          }
        }
      })
    }
  }
}
</script>